module.exports = __webpack_public_path__ + "static/media/types.f25cffb8.svg";